import type { StandingOrders } from './StandingOrders';

export const HR: Partial<StandingOrders> = {
    standingOrderIntervals: ['MONTHLY', 'BI_MONTHLY', 'QUARTERLY', 'HALFYEARLY', 'YEARLY'],
    sweepOrderIntervals: ['DAILY', 'MONTHLY', 'BI_MONTHLY', 'QUARTERLY', 'HALFYEARLY', 'YEARLY'],
    fetchReceiver: true,
    handleLocalErrors: {
        errorCode: 'HR-BE_LOCAL_ERROR',
        translationPath: 'parameters.HR-BE_ERR_TXT',
    },
    useVariableCurrencyFromReceiverAPI: true,
};
